export default "__VITE_ASSET__Cuz1wJJj__"